import React, { Component } from "react";
import moment from "moment";
import { withStyles } from "material-ui/styles";
import Grid from "material-ui/Grid";
import Button from "material-ui/Button";
import Typography from "material-ui/Typography";
import Hidden from "material-ui/Hidden";
import AppBar from "material-ui/AppBar";
import Toolbar from "material-ui/Toolbar";
import ArrowDownward from "material-ui-icons/ArrowDownward";

const styles = (theme) => ({
  background: {
    backgroundImage: "url(/images/header_background.jpg)",
    position: "relative",
    backgroundSize: "cover",
    width: "100%",
    height: "100%",
    backgroundPosition: "50% 52%",
  },
  layer: {
    backgroundColor: "rgba(0, 0, 0, 0.8)",
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  layerMobile: {
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
  },
  callInformations: {
    position: "absolute",
    right: "1rem",
    top: "1rem",
    backgroundColor: "rgba(4, 4, 4, 0.34)",
    padding: "1rem",
  },
  headerWrapper: {
    height: "100%",
  },
  mobileAppBar: {
    backgroundColor: "rgba(0, 0, 0, 0.90)",
    zIndex: 200,
    position: "fixed",
    top: 0,
  },
  mobileBackground: {
    backgroundImage: "url(/images/header_background.jpg)",
    position: "relative",
    backgroundSize: "cover",
    width: "100%",
    height: "187px",
    backgroundPosition: "50% 23%",
    zIndex: 100,
  },
  subTitle: {
    fontSize: "0.7rem",
    display: "inline-block",
    position: "absolute",
    bottom: "0.2rem",
    left: "1.8rem",
    color: "#ffffff",
  },
  logoKanjiDesktop: {
    display: "block",
    position: "absolute",
    maxWidth: "40px",
    height: "auto",
    right: "3px",
    top: "-6px",
  },
  logoKanjiMobile: {
    top: "-2px",
    left: "75px",
    height: "auto",
    display: "block",
    position: "absolute",
    maxWidth: "12px",
  },
  offers: {
    display: "flex",
    marginTop: "2rem",
    justifyContent: "space-between",
    width: "600px",
    alignItems: "center",
    justifyContent: "center",
  },
  offersMobile: {
    paddingTop: "100px",
    paddingLeft: "17px",
  },
  icon: {
    height: "36px",
    width: "36px",
    backgroundColor: "white",
    display: "flex",
    borderRadius: "2px",
    marginRight: "9px",
  },
});

class App extends Component {
  constructor() {
    super();

    this.state = {
      dayIndex: moment().isoWeekday(),
    };
  }

  computeCurrentDayClass(index) {
    if (index === this.state.dayIndex) {
      return "current-day";
    }

    return null;
  }

  render() {
    const { classes } = this.props;

    return [
      <Hidden only={["xs", "sm"]}>
        <div className={classes.background}>
          <div className={classes.layer}>
            <div className={classes.callInformations}>
              <Typography style={{ color: "white", marginBottom: "0.5rem" }}>
                Réserver / Commander
              </Typography>
              <Typography color="primary">
                <b>01 47 75 22 52</b>
              </Typography>
            </div>
            <div style={{ position: "relative", marginBottom: "-1rem" }}>
              <img
                style={{ maxWidth: "250px" }}
                alt="logo"
                src="/images/logo-machiso.png"
              />
            </div>
            <Typography style={{ color: "white" }} variant="subheading">
              Restaurant Coréen situé à Puteaux
            </Typography>
            <div className={classes.offers}>
              <div>
                <Typography
                  style={{ color: "white", textTransform: "uppercase" }}
                  variant="title"
                >
                  À emporter
                </Typography>
                <Typography style={{ color: "white" }}>
                  {/* à partir de 25€ */}
                  {/* <br /> */}
                  {/* <b>à partir de 25€, 1 canette (33cl) offerte</b>
                  <br />
                  <b>à partir de 40€, 1 bière (33cl) offerte</b> */}
                  à partir de 25€, 1 canette (33cl) offerte{" "}
                  <span style={{ color: "white", fontSize: "10px" }}>
                    (uniquement le soir)
                  </span>
                  <br />à partir de 40€, 1 bière (33cl) offerte{" "}
                  <span style={{ color: "white", fontSize: "10px" }}>
                    (uniquement le soir)
                  </span>
                </Typography>
              </div>
              {/* <div>
                <Typography
                  style={{ color: "white", textTransform: "uppercase" }}
                  variant="title"
                >
                  plat à emporter <span style={{ color: "#f44336" }}>-10%</span>
                </Typography>
                <Typography style={{ color: "white" }}>
                  à partir de 15€, uniquement le soir
                  <br />
                </Typography>
              </div> */}
            </div>
            <ArrowDownward
              id="arrowContinue"
              color="primary"
              fontSize={true}
              style={{ position: "absolute", bottom: "2rem", fontSize: "3rem" }}
            />
          </div>
        </div>
      </Hidden>,
      <Hidden only={["md", "lg", "xl"]}>
        <AppBar position="static" className={classes.mobileAppBar}>
          <Toolbar>
            <div style={{ position: "relative", flex: 1 }}>
              <img
                style={{ maxWidth: "78px", opacity: 0.9 }}
                alt="logo"
                src="/images/logo-machiso.png"
              />
            </div>
            {/* <Typography className={classes.subTitle} style={{ color: "white" }}>
              Restaurant Coréen
            </Typography> */}

            {/* <a
              href="https://www.ubereats.com/fr-FR/paris/food-delivery/sakura-puteaux/uCq94HD8QCygReymwLviLg/"
              target="_blank"
              title="uber eats"
            >
              <img className={classes.icon} src="/images/uber_eats.png" />
            </a>
            <a
              href="https://deliveroo.fr/fr/menu/paris/nanterre-les-fontenelles/sakura-puteaux#"
              target="_blank"
              title="deliveroo"
            >
              <img className={classes.icon} src="/images/deliveroo.png" />
            </a> */}

            <a className={classes.clickToCall} href="tel:0147752252">
              <Button
                color="primary"
                variant="raised"
                title="Appeler"
                style={{ textTransform: "none" }}
              >
                01 47 75 22 52{" "}
                <span
                  style={{
                    display: "inline-block",
                    fontSize: "10px",
                    marginLeft: "8px",
                  }}
                ></span>
              </Button>
            </a>
          </Toolbar>
        </AppBar>
        <div className={classes.mobileBackground}>
          <div className={classes.layerMobile}>
            <div className={classes.offersMobile}>
              <div style={{ width: "100%" }}>
                <Typography
                  style={{
                    color: "white",
                    textTransform: "uppercase",
                    fontSize: "16px",
                  }}
                  variant="title"
                >
                  À emporter
                </Typography>
                <Typography style={{ color: "white", fontSize: "13px" }}>
                  {/* à partir de 25€ */}
                  {/* <br /> */}
                  {/* <b>à partir de 25€, 1 canette (33cl) offerte</b>
                  <br />
                  <b>à partir de 40€, 1 bière (33cl) offerte</b> */}
                  à partir de 25€, 1 canette (33cl) offerte{" "}
                  <span style={{ color: "white", fontSize: "10px" }}>
                    (uniquement le soir)
                  </span>
                  <br />à partir de 40€, 1 bière (33cl) offerte{" "}
                  <span style={{ color: "white", fontSize: "10px" }}>
                    (uniquement le soir)
                  </span>
                </Typography>
              </div>
              {/* <div style={{ width: "100%", marginTop: "1rem" }}>
                <Typography
                  style={{ color: "white", textTransform: "uppercase" }}
                  variant="title"
                >
                  plat à emporter <span style={{ color: "#f44336" }}>-10%</span>
                </Typography>
                <Typography style={{ color: "white" }}>
                  à partir de 15€, uniquement le soir
                  <br />
                </Typography>
              </div> */}
            </div>
          </div>
        </div>
      </Hidden>,
    ];
  }
}

export default withStyles(styles)(App);



// WEBPACK FOOTER //
// ./src/components/Header/Header.js